import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Action } from '../action';

export interface DialogData {
  title: string;
  message: string;
  actions: Action[];
}

@Component({
    selector: 'app-shipment-confirmation-input-dialog',
    templateUrl: './shipment-confirmation-input-dialog.component.html',
    styleUrls: ['./shipment-confirmation-input-dialog.component.scss'],
    standalone: false
})
export class ShipmentConfirmationInputDialogComponent implements OnInit {
  inputValue: number;

  constructor(
    private dialogRef: MatDialogRef<ShipmentConfirmationInputDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit() {}

  onInputChange(input: any): void {
    this.inputValue = Number(input.value);
  }
}
